

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';
import { Stockitem } from '../../../../interfaces/stockitem';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';
import { GovernoratesService } from '../../../../services/governorates.service';
import { City } from '../../../../interfaces/city';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { PaymentData } from '../../../../interfaces/payment';
import { users } from '../../../../interfaces/users';
import { UserInterface } from '../../../../interfaces/user-interface';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-f-m-homepage',
  templateUrl: './f-m-homepage.component.html',
  styleUrl: './f-m-homepage.component.scss'
})
export class FMHomepageComponent {
  totalAllOrders: number = 0;
  totalAllDue: number = 0;
  totalCompleted: number = 0;
  totalPending: number = 0;
  allData: PaymentData[] = [];
  allUsers: UserInterface[] = [];
  totalItems = 0;
  displayedColumns: string[] = ['order_id', 'due', 'requested', 'complated'];
  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];
  filterCards: Item[] = [];
  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
  governorates: Governorate[] = [];
  city_id?: number;
  location?: Governorate;
  cities: City[] = [];
  id?: string;
  invoiceName?: any;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isMobile!: boolean;
  isSubAdmin!: boolean;
  isUserFilter!: boolean;
  searchKey: string = '';
  page: number = 1;
  userId!: any;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private _homeService: HomeService,
    private deviceService: DeviceDetectorService,
    private _FinancialManager: FinancialManagerService,
    private _userService: UserService,
    private excelExportService: ExcelExportService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile)
      this.router.navigateByUrl('/financial-manager.mobile');

    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
        if (this.isAdmin || this.isSubAdmin) {
          this.displayedColumns.push('order_by', 'delete');
          this.getAllPaymentsData(10, 1);
          this.getAllUsers();
        }
        else {
          this._userService.getUserId().subscribe({
            next: (data) => {
              this.userId = data['user_id'];
              this.getUserPayment(data['user_id'], 1);
            },
            error: (error) => console.error(error),
          });

        }

      },
      error: (error) => console.error(error),
    });


  }
  getUserPayment(id: string, page: any) {
    this.contentReady = true;

    this._FinancialManager.getUserPayement(id, page).subscribe({
      next: (data: any) => {

        this.allData = data.data;
        this.dataSource = new MatTableDataSource(this.allData);

        // 🔥 pagination
        this.stockTotal = data.total;
        this.totalItems = data.last_page;

        // 🔥 totals الجديدة
        this.totalAllOrders = data.total_all_orders;
        this.totalAllDue = Number(data.total_all_due);
        this.totalCompleted = data.total_completed;
        this.totalPending = data.total_pending;

        this.noData = this.allData.length === 0;
        this.contentReady = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }
  getAllPaymentsData(perpage: any, page: any) {
    this.contentReady = true;

    this._FinancialManager.getPayments(perpage, page).subscribe({
      next: (data: any) => {

        this.allData = data.data;
        this.dataSource = new MatTableDataSource(this.allData);

        // 🔥 هنا الربط الصح
        this.totalAllOrders = data.total_all_orders;
        this.totalAllDue = Number(data.total_all_due);
        this.totalCompleted = data.total_completed;
        this.totalPending = data.total_pending;

        this.stockTotal = data.total; // paginator
        this.totalItems = data.last_page;

        this.noData = this.allData.length === 0;
        this.contentReady = false;
      }
    });
  }
  userFilter(id: string) {
    this.isUserFilter = true;
    this.contentReady = true;
    this.getUserPayment(id, 1)
  }
  exportToExcel(): void {
    this.excelExportService.exportToExcel('afiliationpaymenttable', 'afiliationpayment', ['delete']);
  }
  paymentCompleted(id: any, due: any, user: any) {
    this._FinancialManager.complated(id).subscribe({
      next: (data) => {
        this.addEx(user, due)
        this.getAllPaymentsData(10, 1);
      },
      error: (error) => console.error(error),
    });

  }
  addEx(userlast: any, total: any) {
    const bonusPayload = {
      warehouse_id: localStorage.getItem("posId"),
      employee_id: this.userId,
      username: localStorage.getItem("username"),
      amount: total,
      note: userlast,
      type: "0"
    };
    this._FinancialManager.addexpenses(bonusPayload).subscribe({
      next: (data) => {

      },
      error: (error) => console.error(error),
    });
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }
  onPaginateChange(event: PageEvent) {

    const newPage = event.pageIndex + 1;
    if (this.isAdmin || this.isSubAdmin) {
      this.getAllPaymentsData(10, newPage);

    }
    else if (this.isUserFilter) {
      this.getUserPayment(this.userId, newPage);

    }
    else {
      this.getUserPayment(this.userId, newPage);
    }
  }
  getAllUsers() {
    this.contentReady = true;
    this.searched = false;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allUsers = data
          .filter((user: any) =>
            ["2"].includes(user.type)
          )
          .reverse();

        this.contentReady = false;
        if (this.allUsers.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
}
